import { type FunctionComponent, type ReactNode, Suspense } from 'react';

import Loading from './Loading';

interface Props {
  fallback?: ReactNode;
  [key: string]: any;
}

const Loadable = (Component: FunctionComponent) => {
  return ({ fallback = <Loading />, ...restProps }: Props) => (
    <Suspense fallback={fallback}>
      <Component {...restProps} />
    </Suspense>
  );
};

export default Loadable;
